import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ImportFileNewTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/ImportFileNewTemplatePage";
import Classes, { ACHTemplate, Company, CompanyAccount } from "model";

/**
 * @name CaptureNewTemplateColumn2Dropdown
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureNewTemplateColumn2Dropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "",
        creditAmount: "0.00",
        debitAmount: "0.00",
        achToParticipants: [],
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "0"
    });

    let selectedColumns = getDefaultData().selectedColumns;
    let mapColumns = getDefaultData().mapColumns;
    selectedColumns.shift();
    
    mapColumns = mapColumns.reduce((acc, item, i) => {
        if(item.isSelected !== undefined && i === 1) {
            item.isSelected = true;
        }
        return [...acc, item]
    }, []);
    
    selectedColumns = [ 
        { id: "0", value: { id: "1", value: "Name (Required)", class: "name" }, isSelected: false },
        ...selectedColumns
    ];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template" ], selectedTemplate)
    .update([ "selectedColumns" ], selectedColumns)
    .update([ "mapColumns" ], mapColumns)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "mapColumnSelect2", "isActive" ], true)
    .submit();

    return <ImportFileNewTemplatePage data={ data } ui={ ui } />;
}